import { uiNotify } from "../../actions";

export const PRODUCTS_LOADED = "PRODUCTS_LOADED";

export const getProducts = (catalogId, categoryId, marcaId) => (dispatch) => {
  const language = window.ferrero ? window.ferrero.locale : "es_ES";

  dispatch(uiNotify({ text: "Loading data..." }));

  if (!categoryId) categoryId = "*";
  if (!catalogId) catalogId = "*";

  const ES_URL = `/api/es/catalog/${catalogId}/${categoryId}/${marcaId}`;
  const PT_URL = `/api/pt/catalog/${catalogId}/${categoryId}/${marcaId}`;

  return fetch(language === "es_ES" ? ES_URL : PT_URL)
    .then((res) => res.json())

    .then((data) => {
      dispatch(uiNotify({ text: "Products data loaded" }));

      return dispatch({
        type: PRODUCTS_LOADED,
        payload: {
          data: data,
        },
      });
    })

    .catch((error) => {
      console.log(error);
      dispatch(
        uiNotify({
          text: error,
        })
      );
      return dispatch(error);
    });
};

export const PRODUCTS_BY_EAN_LOADED = "PRODUCTS_BY_EAN_LOADED";

export const getProductsByEAN =
  (catalogId, categoryId, marcaId, ean) => (dispatch) => {
    const language = window.ferrero ? window.ferrero.locale : "es_ES";

    dispatch(uiNotify({ text: "Loading data..." }));

    if (!categoryId) categoryId = "*";
    if (!catalogId) catalogId = "*";
    if (!marcaId) marcaId = "*";

    const ES_URL = `/api/es/catalog/${catalogId}/${categoryId}/${marcaId}/${ean}`;
    const PT_URL = `/api/pt/catalog/${catalogId}/${categoryId}/${marcaId}/${ean}`;

    return fetch(language === "es_ES" ? ES_URL : PT_URL)
      .then((res) => res.json())

      .then((data) => {
        dispatch(uiNotify({ text: "Product by ean loaded" }));

        return dispatch({
          type: PRODUCTS_BY_EAN_LOADED,
          payload: {
            data: data,
          },
        });
      })

      .catch((error) => {
        console.log(error);
        dispatch(
          uiNotify({
            text: error,
          })
        );
        return dispatch(error);
      });
  };

export const PRODUCTS_BY_ITF_LOADED = "PRODUCTS_BY_ITF_LOADED";

export const getProductsByITF =
  (catalogId, categoryId, marcaId, ean, itf) => (dispatch) => {
    const language = window.ferrero ? window.ferrero.locale : "es_ES";

    dispatch(uiNotify({ text: "Loading data..." }));

    if (!categoryId) categoryId = "*";
    if (!catalogId) catalogId = "*";
    if (!marcaId) marcaId = "*";
    

    const ES_URL = `/api/es/catalog/${catalogId}/${categoryId}/${marcaId}/${ean}/${itf}`;
    const PT_URL = `/api/pt/catalog/${catalogId}/${categoryId}/${marcaId}/${ean}/${itf}`;

    return fetch(language === "es_ES" ? ES_URL : PT_URL)
      .then((res) => res.json())

      .then((data) => {
        dispatch(uiNotify({ text: "Product by itf loaded" }));

        return dispatch({
          type: PRODUCTS_BY_ITF_LOADED,
          payload: {
            data: data,
          },
        });
      })

      .catch((error) => {
        console.log(error);
        dispatch(
          uiNotify({
            text: error,
          })
        );
        return dispatch(error);
      });
  };

export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS";

export const searchProducts = (data) => (dispatch) => {
  const language = window.ferrero ? window.ferrero.locale : "es_ES";
  dispatch(uiNotify({ text: "Loading data..." }));

  const ES_URL = `/api/es/catalog/${data.catalogoId}/search?search=${data.key}`;
  const PT_URL = `/api/pt/catalog/${data.catalogoId}/search?search=${data.key}`;

  return fetch(language === "es_ES" ? ES_URL : PT_URL)
    .then((res) => res.json())

    .then((data) => {
      dispatch(uiNotify({ text: "Search products loaded" }));

      return dispatch({
        type: SEARCH_PRODUCTS,
        payload: {
          data: data.products,
        },
      });
    })

    .catch((error) => {
      console.log(error);
      dispatch(
        uiNotify({
          text: error,
        })
      );
      return dispatch(error);
    });
};

export const SELECTED_CUSTOM_PRODUCTS = "SELECTED_CUSTOM_PRODUCTS";

export const selectedCustomProducts = (products) => (dispatch) => {

      return dispatch({
        type: SELECTED_CUSTOM_PRODUCTS,
        payload: {
          data: products,
        },
      });

};



export const POST_CUSTOM_PRODUCTS = "POST_CUSTOM_PRODUCTS";

export const postCustomProducts = (data) => (dispatch) => {
 
  const language = window.ferrero ? window.ferrero.locale : "es_ES";
  
  dispatch(uiNotify({ text: "Loading data..." }));

  const ES_URL = `/api/es/catalog/${data.catalogoId}`;
  const PT_URL = `/api/pt/catalog/${data.catalogoId}`;

  return fetch(language === "es_ES" ? ES_URL : PT_URL, {
    method: "POST",
    headers: {
      Accept: "application/json;odata=verbose",
      'Content-Type': 'application/json'

    },
    body: JSON.stringify(data.modalValue)
  })
    .then((res) => res.json())

    .then((data) => {

      dispatch(uiNotify({ text: "Catalog data loaded" }));

      return dispatch({
        type: POST_CUSTOM_PRODUCTS,
        payload: {
          data: data.catalogs,
        },
      });
    })

    .catch((error) => {
      console.log(error);
      dispatch(
        uiNotify({
          text: error,
        })
      );
      return dispatch(error);
    });
};



export const PRODUCT_DELETE = "PRODUCT_DELETE";

export const deleteProducts = ({catalogId, categoryId, groupId, ean, itf}) => (dispatch) => {

  const language = window.ferrero ? window.ferrero.locale : "es_ES";
  
  dispatch(uiNotify({ text: "Loading data..." }));

  let ES_URL;
  let PT_URL;

  if(catalogId && categoryId) {
    ES_URL = `/api/es/catalog/${catalogId}/${categoryId}`
    PT_URL = `/api/pt/catalog/${catalogId}/${categoryId}`
  }


  if(catalogId && categoryId && groupId ) {
    ES_URL = `/api/es/catalog/${catalogId}/${categoryId}/${groupId}`
    PT_URL = `/api/pt/catalog/${catalogId}/${categoryId}/${groupId}`
  }

  if(catalogId && categoryId && groupId && ean) {
    ES_URL = `/api/es/catalog/${catalogId}/${categoryId}/${groupId}/${ean}`
    PT_URL = `/api/pt/catalog/${catalogId}/${categoryId}/${groupId}/${ean}`
  }

  if(catalogId && categoryId && groupId && ean && itf) {
    ES_URL = `/api/es/catalog/${catalogId}/${categoryId}/${groupId}/${ean}/${itf}`
    PT_URL = `/api/pt/catalog/${catalogId}/${categoryId}/${groupId}/${ean}/${itf}`
  }


  return fetch(language === "es_ES" ? ES_URL : PT_URL, {
    method: "DELETE",
    headers: {
      Accept: "application/json;odata=verbose",
      'Content-Type': 'application/json'

    },
  })
    .then((res) => res.json())

    .then((data) => {
      dispatch(uiNotify({ text: "Catalog data loaded" }));

      return dispatch({
        type: PRODUCT_DELETE,
        payload: {
          data: data,
        },
      });
    })

    .catch((error) => {
      console.log(error);
      dispatch(
        uiNotify({
          text: error,
        })
      );
      return dispatch(error);
    });
};